export default __webpack_public_path__ + "static/media/(2).d0a98a3a.jpeg";